<template>
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home-1"
        transform="translate(-1784.000000, -97.000000)"
        stroke="#000000"
        stroke-width="2"
      >
        <g id="Nav" transform="translate(40.000000, 98.000000)">
          <g id="Group-5" transform="translate(1682.000000, 0.000000)">
            <g id="Person" transform="translate(63.000000, 0.000000)">
              <path
                d="M11.5,0 C17.8510667,0 23,5.14893333 23,11.5 C23,17.8510667 17.8510667,23 11.5,23 C5.14893333,23 0,17.8510667 0,11.5 C0,5.14893333 5.14893333,0 11.5,0 Z"
                id="Stroke-1"
              ></path>
              <path
                d="M11.5,6 C13.7096,6 15.5,7.7904 15.5,10 C15.5,12.2096 13.7096,14 11.5,14 C9.2904,14 7.5,12.2096 7.5,10 C7.5,7.7904 9.2904,6 11.5,6 Z"
                id="Stroke-3"
              ></path>
              <path
                d="M4,20 C4.78947368,16.55 7.86842105,14 11.5,14 C15.1315789,14 18.2105263,16.55 19,20"
                id="Stroke-5"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-account",
};
</script>

<style scoped lang="scss">
path {
  transition: stroke 0.3s ease;
}
.theme-dark svg {
  path {
    stroke: #ffffff;
  }
  &:hover {
    path {
      stroke: #666;
    }
  }
}

.theme-light svg {
  path {
    stroke: #000000;
  }
  &:hover {
    path {
      stroke: #666;
    }
  }
}
</style>
